import { deletePadding, setPadding } from "store/features/memeGenerator/actions";
import { PaddingColor, PaddingType } from "store/features/memeGenerator/types/padding";
import { useAppDispatch, useAppSelector } from "store/store";

export const usePadding = () => {
    const padding = useAppSelector((state) => state.memeGenerator.meme?.padding);
    const dominantColor = useAppSelector((state) => state.memeGenerator.meme?.dominantColor);
    const dispatch = useAppDispatch();
    function handlePaddingOptionClick(type: PaddingType) {
        dispatch(
            setPadding({
                type,
            }),
        );
    }
    function handlePaddingColorClick(color: PaddingColor) {
        dispatch(
            setPadding({
                color,
            }),
        );
    }
    function handlePaddingValue(value: number) {
        if (value < 0 || value > 100) throw new Error(`Invalid padding value: ${value}`);
        dispatch(
            setPadding({
                value,
            }),
        );
    }
    function handleDelete() {
        dispatch(deletePadding());
    }
    return {
        padding,
        dominantColor,
        handlePaddingOptionClick,
        handlePaddingColorClick,
        handlePaddingValue,
        handleDelete,
    };
};
